<template>
  <v-container class="pa-0" fluid>

    <v-row no-gutters v-show="hideOverlayRoute">
      <v-col v-if="showFilterPane" :cols="isPhoneBool ? 12 : 3" class="pane filterpane">
        <slot name="filter">
          filter
        </slot>
      </v-col>
      <v-col :cols="listCols" class="pane">
        <slot name="list">
          list
        </slot>
      </v-col>
      <v-col v-if="showPreviewPane" :cols="previewCols" class="pane previewpane inset">
        <slot name="preview">
          preview
        </slot>
      </v-col>
    </v-row>

    <!-- Used to render subroutes over this component without un -->
    <v-row no-gutters>
      <v-col cols="12" class="pane" v-if="!hideOverlayRoute" style="position: absolute; background-color: white;">
        <router-view @Added="e => $emit('Added', e)" @Changed="e => $emit('Changed', e)">
          Overlay Route Content
        </router-view>
      </v-col>
    </v-row>
  </v-container>
</template>


<script>
export default {
  name: "PreviewableListLayout",
  props: {
    hideFilter: {
      default: true,
      type: Boolean,
    },
    hidePreview: Boolean,
    hideOverlayRoute: {
      default: true,
      type: Boolean,
    },
  },
  components: {},

  data() {
    return {
      colwidths: {
        pc: {
          filter: 3,
          list: 5 - 6 - 12,
          preview: 4 - 6,
        },
        pad: {
          filter: 12,
          list: 6 - 12,
          preview: 6,
        },
        phone: {
          filter: 12,
          list: 12,
          preview: 12,
        },
      },
    };
  },

  mounted() { },

  methods: {},

  computed: {
    listCols() {
      if (this.showPreviewPane && this.showFilterPane) {
        //list filter and preview
        return this.isPhoneBool ? 12 : this.isPadBool ? 6 : 5;
      } else if (this.showFilterPane) {
        //only filter and list
        return this.isPhoneBool ? 12 : this.isPadBool ? 9 : 9;
      } else if (this.showPreviewPane) {
        // only preview and list
        return this.isPhoneBool ? 12 : this.isPadBool ? 6 : 6;
      } else {
        // only list
        return 12;
      }
    },

    previewCols() {
      if (this.showFilterPane) {
        //list filter and preview
        return this.isPhoneBool ? 12 : this.isPadBool ? 6 : 4;
      } else {
        // else
        return this.isPhoneBool ? 12 : 6;
      }
    },

    showPreviewPane() {
      return !this.hidePreview;
    },
    showFilterPane() {
      return !this.hideFilter;
    },
  },

  watch: {},
};
</script>

<style lang="scss">
.pane {
  height: 100%;
  overflow-y: auto !important;
}

.filterpane {
  position: relative;
}

.filterpane:after {
  position: absolute;
  top: 48px;
  right: 0;
  height: calc(100% - 48px);
  border-right: solid 1px rgb(230, 230, 230);
  content: '';
}

@media only screen and (max-width: 600px) {
  .listpane {
    height: auto !important;
  }

  #ContentContainer .pane.previewpane {
    height: 0 !important;
  }
}
</style>